<template>
  <el-dialog width="32%"
             :visible.sync="visible"
             title="预算调整">
    <el-form :model="model"
             size="medium"
             :rules="formRules"
             label-width="120px">
      <el-form-item label="追加前端预算"
                    prop="'predict_frontend_cost">
        <el-input v-model="model.predict_frontend_cost">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="追加其他预算"
                    prop="predict_others_cost">
        <el-input v-model="model.predict_others_cost">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="追加后端预算"
                    prop="predict_backend_cost">
        <el-input v-model="model.predict_backend_cost">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="追加标注预算"
                    prop="predict_label_cost">
        <el-input v-model="model.predict_label_cost">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="调整原因"
                    prop="desc">
        <el-input v-model="model.desc"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer"
         class="dialog-footer">
      <el-button @click="visible = false"
                 size="small">取消
      </el-button>
      <el-button type="primary"
                 @click="submit"
                 size="small">提交
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      visible: false,
      model: {
        id: null,
        desc: null,
        predict_frontend_cost: null,
        predict_others_cost: null,
        predict_backend_cost: null,
        predict_label_cost: null,
      },
      formRules: {
        // predict_frontend_cost: [
        //   {required: true, message: '前端预算不能为空', trigger: 'blur'},
        // ],
        // predict_others_cost: [
        //   {required: true, message: '追加预算不能为空', trigger: 'blur'},
        // ],
        desc: [
          {required: true, message: '调整原因不能为空', trigger: 'blur'},
        ],
      },
    }
  },
  watch: {
    visible (value) {
      if (!value) {
        Object.assign(this.$data, this.$options.data.call(this))
      }
    }
  },
  methods: {
    open (id) {
      this.model.id = id
      this.visible = true
    },
    close () {
      this.visible = false
    },
    getForm () {
      const form = filter.copyJson(this.model)
      form.predict_frontend_cost = form.predict_frontend_cost || 0
      form.predict_others_cost = form.predict_others_cost || 0
      form.predict_backend_cost = form.predict_backend_cost || 0
      form.predict_label_cost = form.predict_label_cost || 0
      return form
    },
    submit () {
      request.common('updateProjectBudget4Ajx', this.getForm()).then(() => {
        this.visible = false
        this.$message.success('修改成功')
        this.model = {}
        this.$emit('submitted')
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/customer-project/components/AjxUpdateBudgetDialog.vue